import { useQuery } from 'react-query';
import {
  GET_WALLET_MESSAGE_TYPE,
  getWalletBenefitCard,
  UserWalletBenefitCard,
} from '@leagueplatform/wallet-api';

// setting a staleTime of 5 minutes to avoid unnecessary re-fetches
const STALE_TIME = 1000 * 60 * 5;

export function useWalletDetailQuery<TSelect = UserWalletBenefitCard>(
  benefitId?: string,
) {
  return useQuery<UserWalletBenefitCard, unknown, TSelect>(
    // userId and dependentId are not needed for useWalletDetailQuery, but are part of the function params.
    // If we ever need to reuse this hook with more params, we'll update it then.
    [GET_WALLET_MESSAGE_TYPE, undefined, benefitId, undefined],
    () => getWalletBenefitCard(undefined, benefitId, undefined),
    {
      staleTime: STALE_TIME,
    },
  );
}
